export enum PhotographyPotential {
  DONT_CARE = 'dont-care',
  CRUCIAL = 'crucial',
  IMPORTANT = 'important',
}

export const possiblePhotographyPotentials = [
  PhotographyPotential.DONT_CARE,
  PhotographyPotential.IMPORTANT,
  PhotographyPotential.CRUCIAL,
]

export enum PhoneSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const possiblePhoneSizes = [PhoneSize.SMALL, PhoneSize.MEDIUM, PhoneSize.LARGE]

export enum PhoneCondition {
  REFURBISHED = 'refurbished',
  REFURBISHED_B = 'refurbished_b',
  REFURBISHED_C = 'refurbished_c',
  NEW = 'new',
}

export enum PhoneCondensedCondition {
  REFURBISHED = 'refurbished',
  NEW = 'new',
}

export const possiblePhoneConditions = [
  PhoneCondition.REFURBISHED,
  PhoneCondition.NEW,
  PhoneCondition.REFURBISHED_B,
  PhoneCondition.REFURBISHED_C,
]

export const possiblePhoneCondensedConditions = [PhoneCondensedCondition.REFURBISHED, PhoneCondensedCondition.NEW]

export interface PhoneSpecs {
  position: number
  slug: string
  name: string
  osName: string
  osSlug: string
  brandSlug: string
  brandName: string
  photography: null | PhotographyPotential
  size: null | PhoneSize
  monthly: number
  modelId: number
  modelSlug: string
  modelMemorySize: number
  modelMemorySlug: string
  modelMemoryName: string
  modelPrice: number
  hasWifiCalling: boolean
  modelCondition: string
  modelPriceTier: null | number
}

export interface PhoneSpecsCondensed {
  position: number
  phoneId: number
  slug: string
  name: string
  osName: string
  osSlug: string
  brandSlug: string
  brandName: string
  photography: null | PhotographyPotential
  size: null | PhoneSize
  hasWifiCalling: boolean
  hasNew: boolean
  hasRefurbished: boolean
  avgModelPriceTier: number
}
